import { StandardSidebar } from '@public/components/Layouts/StandardSidebar';
import clsx from 'clsx';

import styles from './AdSidebarLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
  sidebarContent?: React.ReactNode;
  sidebarMobile?: boolean;
}

export const AdSidebarLayout = ({
  children,
  sidebarContent,
  sidebarMobile = true,
}: ComponentProps) => {
  return (
    <main className={styles.container}>
      <div>{children}</div>
      <StandardSidebar
        className={clsx(styles.sidebar, {
          [styles.hideMobile]: !sidebarMobile,
        })}
      >
        {sidebarContent}
      </StandardSidebar>
    </main>
  );
};
